import React, { FC, ReactNode } from 'react';
import Navbar from '../nav-bar/Navbar';
import s from './BaseLayout.module.css';
import { useLocation } from 'react-router-dom';
import PricingModal from '../pricing-modal/PricingModal';

interface LayoutProps {
    children: ReactNode;
}

const BaseLayout: FC<LayoutProps> = ({ children }) => {
    const location = useLocation();
    const isProjectPage = location.pathname.includes('/text_project');
    const isImageProjectPage = location.pathname.includes('/image_project');
    const isAuthPage = location.pathname.includes('/auth');
    const isDashboardPage = location.pathname.includes('/dashboard');
    const isCreatePostPage = location.pathname.includes('/create-post');
    const isSettingsPage = location.pathname.includes('/settings');
    const isSchedulePostPage = location.pathname.includes('/schedule');
    const isNavbarPage = isDashboardPage || isSettingsPage || isSchedulePostPage;

    return (
        <div className={s.base_layout}>
            {isAuthPage || isCreatePostPage ? (
                <div className={s.auth_page}>{children}</div>
            ) : (
                <>
                    <div className={`${isNavbarPage ? s.content_wrapper : s.layout_wrapper}`}>
                        {isNavbarPage && <Navbar />}
                        {children}
                    </div>
                </>
            )}
            <PricingModal />
        </div>
    );
};

export default BaseLayout;
